module.exports = __webpack_public_path__ + "static/media/interview23.10b1db15.jpg";